// src/pages/ProductDetails.js
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { ProductsList } from "../source/productsList";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom"; // ✅ Add this at top

export default function ProductDetails() {
    const { id } = useParams();
    const product = ProductsList.find((item) => item.id === id);
    const [navbarState, setNavbarState] = useState(false);
    const [navbarStateName, setNavbarStateName] = useState('home');
    const html = document.querySelector("html");
    html.addEventListener("click", () => setNavbarState(false));
  
    const navigate = useNavigate();

    const handleNavigation = (target) => {
       // setNavbarStateName('contact');
        navigate(target);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    if (!product) return <Container><h2>Product not found</h2></Container>;

    return (
        <div style={{padding: '1em'}}>
            <div className="breadcrumb">Home &gt;  {product.name}</div>
            <Container>
                <div className="image">
                    <img src={product.image} alt={product.name} />
                </div>
                <div className="content">
                    <h1>{product.name}</h1>
                    <p>{product.details}</p>
                    {/* <a href="#" onClick={() => handleNavigation("contact")} className="form-link">Click Here (Form Link)</a> */}

                    <Link to="/contact" className="form-link">
  Click Here (Form Link)
</Link>
                </div>
            </Container>
        </div>
    );
}

const Container = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 800px;
  margin: auto;
   max-width: 900px;
    margin: 0 auto;
    padding: 24px;
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    margin-top: 2em;
    margin-bottom: 2em;

  .image img {
    width: 100%;
    border-radius: 1rem;
  }

  .content h1 {
    color: #fc4958;
    margin-bottom: 1rem;
  }

  .content p {
    font-size: 1.1rem;
    line-height: 1.6;
    white-space: pre-wrap;
  }

  .form-link {
    display: inline-block;
    margin-top: 1.5rem;
    color: #007bff;
    text-decoration: underline;
    font-weight: bold;
  }

  @media (max-width: 768px) {
    padding: 1rem;

  .content p {
    font-size: 0.9rem;
    line-height: 1.6;
  }
  }
`;
